export class FormError extends Error {
  public fieldName?: string | null;

  constructor(message: string, fieldName?: string | null) {
    super(message);
    this.name = 'FormError';
    this.fieldName = fieldName;
  }
}
